// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s9IY","placeholdersHeader":"styles_placeholdersHeader__EvSuS","editorStyle":"styles_editorStyle__29661","placeholdersBox":"styles_placeholdersBox__2RRM0"};